/**
 * Shared navigation menu config and visibility helpers.
 * Data lives in nav-menu.json (single source of truth).
 * Static HTML pages load the same JSON from /js/nav-menu.json (synced on build).
 */

import NAV_MENU_ITEMS from './nav-menu.json';

export { NAV_MENU_ITEMS };

export function isInternalStaff(userRole) {
  return Boolean(userRole && !['external', 'reseller', 'client'].includes(userRole));
}

export function isResellerOrStaff(userRole) {
  return userRole === 'reseller' || isInternalStaff(userRole);
}

export function isItemComingSoon(item, userRole) {
  return Boolean(item && item.previewForInternal && !isInternalStaff(userRole));
}

export function isItemRestricted(item, userRole) {
  const internal = isInternalStaff(userRole);
  if (item.internalOnly && !internal) return true;
  if (!item.restrictedFor) return false;
  return item.restrictedFor.includes(userRole);
}

export function groupByCategory(items, userRole) {
  const visible = items.filter((item) => !isItemRestricted(item, userRole));
  const categories = [...new Set(visible.map((item) => item.category))];
  return categories.map((category) => ({
    category,
    items: visible.filter((item) => item.category === category),
  }));
}

export function getVisibleMenuItems(userRole) {
  return NAV_MENU_ITEMS.filter((item) => !isItemRestricted(item, userRole));
}
